import React, { useState } from "react"
import { Link } from "react-router-dom"

function CbOSEFooterContainer({ containerObject, templateName, contentId, dataZone }) {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear())

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className="vast-plugin-content">
            <div class="footer-wrapper mt-auto ">
                <div class="container-ose">
                    <div class="row g-4 justify-content-center">
                        <div class="col-8 col-md-2 col-lg-2 text-center text-md-start order-3 order-md-1 mt-5 mb-5 mt-md-4">
                            <a class="d-block me-0" href="/k-8-curriculum-programs" target="_blank">
                                <img class="img-fluid" src="/vaststatic/deployed-assets/CbOSESkin/curriculum-logo.png" alt="logo" />
                            </a>
                            <div className="address">
                                © {currentYear}  Carolina Biological Supply Company <br /> 2700 York Road, Burlington, NC 27215-3398 <br />
                                800.334.5551
                            </div>
                        </div>
                        <div class="col-8 col-md-4 col-lg-4  text-center  text-md-start order-4 order-md-2 mt-3 mt-md-4 ms-0 ps-xxl-4">
                            <ul class="os-badge-list-group">
                                <li class="os-badge-list-group-item">
                                    <img src="/vaststatic/deployed-assets/CbOSESkin/edtechaward-2023-wht.png" class="os-img-thumbnail img-fluid" alt="test" />
                                </li>
                            </ul>
                        </div>
                        <div class="col-8 col-md-3 col-lg-3 text-center  text-md-start order-2 order-md-3 mt-0 mt-md-4 ps-xxl-5 os-footer-second-left">
                            <ul class="nav flex-column">
                                <li class="nav-item">
                                    <Link class="nav-link" to="/ose/openscied-carolina-help">Help</Link></li>
                                <li class="nav-item">
                                    <a class="nav-link" href="/help/terms-of-use" target="_blank" >Terms &amp; Conditions</a></li>
                                <li class="nav-item">
                                    <Link class="nav-link" to="/ose/openscied-carolina-contact-page">Contact Us</Link></li>
                            </ul>
                        </div>
                        <div class="col-8 col-md-3 col-lg-3 text-center  text-md-start order-1 order-md-4 mt-md-4 ps-xxl-5 os-footer-space-left">
                            <ul class="nav flex-column">
                                <li class="nav-item"><Link class="nav-link" to="/ose/openscied-carolina-faqs-page">FAQ&#39;s</Link></li>
                                <li class="nav-item"><a class="nav-link" href="/help/media-room" target="_blank">Media Room</a></li>
                                <li class="nav-item"><Link class="nav-link" to="/ose/openscied-carolina-partner-page">More about our Partner</Link></li>
                            </ul>
                        </div>
                    </div>
                </div >
            </div >
        </div >
    )
}
export default CbOSEFooterContainer